import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2';

const ITEM_FAVORITING_AB_TEST_NAME = 'Favorites_DriveItemFavoritesAdoption_Nov2025';

const isItemFavoritingVariant = (): boolean =>
    getAbTestV2(ITEM_FAVORITING_AB_TEST_NAME)?.variant === 'variant';

export { isItemFavoritingVariant, ITEM_FAVORITING_AB_TEST_NAME };
